import React, { useContext, useRef, useState, useEffect } from 'react';
import { } from 'react-router-dom';
import { Row, Col, Form, Input, Button, notification, Modal, Tabs } from 'antd';

import { Auth } from "../../utils/AuthContext";
import Firebase from '../../utils/firebaseConfig';

import miercoles_en from '../../assets/images/temporal/400x100.png';
import miercoles_hover_en from '../../assets/images/temporal/400x100.png';
import jueves_en from '../../assets/images/temporal/400x100.png';
import jueves_hover_en from '../../assets/images/temporal/400x100.png';
import miercoles from '../../assets/images/temporal/400x100.png';
import miercoles_hover from '../../assets/images/temporal/400x100.png';
import jueves from '../../assets/images/temporal/400x100.png';
import jueves_hover from '../../assets/images/temporal/400x100.png';

import '../../assets/css/conferencias.css';

import conferencia_1 from '../../assets/images/temporal/500x400.png';
import conferencia_1_en from '../../assets/images/temporal/500x400.png';


const app = new Firebase();
const mensaje = (tipo, titulo, texto) => {

    notification[tipo]({
        message: titulo,
        description: texto,
    });

}
const layout = {
    wrapperCol: {
        span: 24,
    },
};


const Conferencias = (props) => {

    console.log(props);

    const { url, url_eng, comentarios, webinar, urlfb, urltw, urlyt, urlln, idioma, dia } = props;

    console.log('dia: ', dia);

    const { usuario, datos } = useContext(Auth);

    const [preguntas_popup_usuario, setPreguntasPopUpUsuario] = useState({});
    const ref_form_pregunta = useRef();

    /* descomentar esto*/
  useEffect(() => {
    if(usuario){
      console.log('agregar');
      app.obtener_objeto(webinar+`/respuestas-usuarios-en-vivo${dia}`,'correo',datos.correo, (data) => {
      setPreguntasPopUpUsuario(data);
    });
    }else{
      window.location.href="/";
    }
  }, [usuario,dia]);

    const [select_video, setSelectVideo] = useState(0);
    const [ver_dia, setVerDia] = useState(1);
    const [ver_modal, setVerModal] = useState(false);

    const videos = [
        {
            dia: 1, links: [
                //{index:1,url:'829520761',nombre:'Inauguración',url_en:'',nombre_en:'',img:conferencia_1,img_en:conferencia_1_en},
                { index: 2, url: '829531281', nombre: 'Diseñamos Humanos a través de la Luz', url_en: '830565829', nombre_en: 'We Design Humans Through Light', img: conferencia_1, img_en: conferencia_1_en },
            ]
        },
        {
            dia: 2, links: [
                { index: 2, url: '829531281', nombre: 'Diseñamos Humanos a través de la Luz', url_en: '830565829', nombre_en: 'We Design Humans Through Light', img: conferencia_1, img_en: conferencia_1_en },
            ]
        }
    ]

    const ver_videos = videos.filter((video) => {
        if (video.dia === ver_dia)
            return true;
        else
            return false;
    }).map((vidio) => {
        return (
            <>
                {vidio.links.map((item) => {
                    return (
                        <Col xs={18} md={7} onClick={() => { setVerModal(true); setSelectVideo(item.index) }} className='puntero_clic'>
                            <img src={idioma === 'es' ? item.img : item.img_en} style={{ width: '100%' }} />
                            <p className='nombre_conferencias'>
                                {idioma === 'es' ? item.nombre : item.nombre_en}
                            </p>
                        </Col>
                    )
                })}
            </>
        )
    });

    const ver_select_video = videos.map((vidio) => {
        return (
            <>
                {vidio.links.filter((personas) => {
                    if (personas.index === select_video)
                        return true;
                    else
                        return false;
                }).map((item) => {
                    return (<>
                        <p className='modal_titulo_conferencia'>
                            {idioma === 'es' ? item.nombre : item.nombre_en}
                        </p>
                        <div className="contenedor_video">
                            <iframe className="video" src={idioma === 'es' ? 'https://player.vimeo.com/video/' + item.url : 'https://player.vimeo.com/video/' + item.url_en} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; allowfullscreen;" allowfullscreen="1"></iframe>
                        </div>
                    </>
                    )
                })}

            </>)
    });

    return (
        <>
            <Row justify='center' align="top">
                <Col span={24}>
                    <br /><br /><br /><br />
                </Col>

                <Col span={20} className="contenedor_conferencias" >
                    
                    <p className='titulo_seccion'>{idioma === 'es' ? 'CONFERENCIAS' : 'CONFERENCES'}</p>
                            <Row justify='center'>
                                <Col xs={12} md={8} onClick={() => { setVerDia(1) }} className="puntero_clic">
                                    {idioma === 'es' ?
                                        <img src={ver_dia === 1 ? miercoles_hover : miercoles} style={{ width: '100%' }} />
                                        :
                                        <img src={ver_dia === 1 ? miercoles_hover_en : miercoles_en} style={{ width: '100%' }} />}
                                </Col>
                                <Col xs={12} md={8} onClick={() => { setVerDia(2) }} className="puntero_clic">
                                    {idioma === 'es' ?
                                        <img src={ver_dia === 2 ? jueves_hover : jueves} style={{ width: '100%' }} />
                                        :
                                        <img src={ver_dia === 2 ? jueves_hover_en : jueves_en} style={{ width: '100%' }} />}
                                </Col>
                                <Col span={24}>
                                    <br /><br />
                                </Col>
                            </Row>
                        
                    <Row justify='space-around' align=''>
                        {ver_videos}
                    </Row>
                </Col>
                
                
            </Row>
            <Modal
                visible={ver_modal} onCancel={() => { setVerModal(false); }}
                title={null}
                footer={null}
                closable={true}
                width="750px"
                className=""
                forceRender={true}>
                {ver_select_video}
            </Modal>
        </>
    );
}

export default Conferencias;